var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardTarget(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 249,
    height: 200,
    viewBox: "0 0 249 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M78.88 25.1H1.98s-4.18-5.27 0-8.83c2.3-1.96 5.01-1.75 6.99-1.18 1.28.38 2.57-.49 2.85-1.8.47-2.17 1.9-5 6.05-6.68 4.07-1.65 6.65.87 8.14 3.45.49.86 1.8.73 2.09-.2C29.4 5.75 33.9.34 48.67.34c18.8 0 16.72 10 15.04 14.15a.96.96 0 001.09 1.3c2.9-.62 8.28-1.42 10.7.47 3.38 2.67 3.38 8.83 3.38 8.83",
    id: "a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.47 12.7c-2.06 8.96 19.06 10.12 27.77 10.21 2.41.03 4.81-.2 7.18-.68 7.36-1.5 23.48-5.41 21.22-10.74C53.72 4.6 44.96 9.4 44.96 9.4s1.1-5.19-13.8-8.62c-14.9-3.43-14.85 8-14.85 8S3.06 1.45.47 12.7",
    id: "d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M15.79 4.05L15.63.18.33 8.22l15.46-4.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i",
    d: "M.32.97L14.8.23l-.07 5.7L.33.97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.73.4S-.15 4.38.15 6.7c.2 1.64.94 2.08 1.5 2.22a1.4 1.4 0 001.47-.6C4.66 6.04 1.72.4 1.72.4",
    id: "k"
  }), /*#__PURE__*/React.createElement("path", {
    id: "n",
    d: "M3.82 7.23l4.9-4.55L7.02.15.33 3.3l2.92 5.13.58-1.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.1.11C-.87-1.34.35 21.8.35 21.8h11.05s.16-4.03.56-9.14C12.3 8.33 9.86 3.44 6.11.11",
    id: "q"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.1 4.37s1.92 7.11 7.1 7.77c5.18.66 13.7-5.9 13.7-5.9l-.93-1.87-9 2.52a3.05 3.05 0 01-3.5-1.49L4.77.41.1 4.37",
    id: "t"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.68 3.42a5.61 5.61 0 00-.47-2.06L5 .02l.94 1.87S3.5 3.75.47 5.4c.16-.65.24-1.32.21-1.97",
    id: "w"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EBDE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0DCDF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EBDE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0DCDF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-.01%",
    y1: "50%",
    x2: "99.99%",
    y2: "50%",
    id: "l"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EBDE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0DCDF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "o"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EBDE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0DCDF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "r"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EBDE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0DCDF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "77.34%",
    y1: "60.57%",
    x2: "-46.53%",
    y2: "17.22%",
    id: "u"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EBDE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0DCDF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.36%",
    y1: "53.09%",
    x2: "-401.26%",
    y2: "-208.75%",
    id: "x"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EBDE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0DCDF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(157 45.41)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M78.88 25.1H1.98s-4.18-5.27 0-8.83c2.3-1.96 5.01-1.75 6.99-1.18 1.28.38 2.57-.49 2.85-1.8.47-2.17 1.9-5 6.05-6.68 4.07-1.65 6.65.87 8.14 3.45.49.86 1.8.73 2.09-.2C29.4 5.75 33.9.34 48.67.34c18.8 0 16.72 10 15.04 14.15a.96.96 0 001.09 1.3c2.9-.62 8.28-1.42 10.7.47 3.38 2.67 3.38 8.83 3.38 8.83",
    fill: "url(#b)",
    mask: "url(#c)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M128.78 54.84s-19.03-30.35-3.65-51.62c43.67 11.51 32.23 54.43 32.23 54.43l-28.58-2.81",
    fill: "#FACB57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.13 3.22l.45.12 12.78 40.23 13.68-22.5.47.75-13.83 22.75 3.69 11.6-.85-.08-7.36-23.14-14.66-4.24a48.9 48.9 0 01-.1-.84l14.48 4.18-9.03-28.42.28-.41",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.64 53.03S137.7 8.1 163.32.13c23.5 19 6.3 48.44 6.3 48.44l-24.93 18.85-9.05-14.39",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.62 19.86l10.46 11.9 8.69-31.4.55-.24.27.23-4.66 16.82 13.24-6.43.19.38.16.33-13.87 6.73-7.75 28.03 23.6-10.54-.24.97-23.64 10.55-5.5 19.91-.43.32-.28-.72 9.42-34.03-10.6-12.05.39-.76",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.26 57.46s21.5-22.44 40.23-15.35c3.05 15.68-2.79 27.19-11.05 35.4-12.85 12.76-31.64 17.53-49.2 13.07L104.6 85.1l41.65-27.63",
    fill: "#005C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.49 42.11l.08.47-29.23 27.86 21.78 2.96-.58.72-21.93-2.99-11.42 10.88.13-1.2 22.23-21.2.49-16.7.8-.3-.48 16.24 17.71-16.88.42.14",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.22 33.77a12.42 12.42 0 115.18 24.29 12.42 12.42 0 01-5.18-24.29zm-28.7 24.84c.57.48 3.41.5 6.53-.11a27.6 27.6 0 004.66 6.58c-1.6 2.27-3.05 4.83-2.55 6.11 1.02 2.6 7.83 5.94 9.01 5.84.75-.06 2.84-2.14 4.63-4.84a27.6 27.6 0 007.85 1.48c.48 2.74 1.26 5.6 2.52 6.14 2.56 1.12 9.74-1.33 10.5-2.24.48-.56.5-3.39-.1-6.5a27.59 27.59 0 006.82-4.51c2.2 1.53 4.63 2.86 5.86 2.37 2.6-1.02 5.94-7.83 5.84-9-.06-.7-1.85-2.56-4.28-4.26 1-2.65 1.6-5.47 1.74-8.38 2.47-.48 4.83-1.23 5.33-2.37 1.11-2.56-1.34-9.74-2.25-10.5-.5-.43-2.84-.49-5.56-.05a27.61 27.61 0 00-4.95-7.4c1.3-2 2.3-4.03 1.87-5.13-1.01-2.6-7.83-5.94-9-5.84-.65.06-2.28 1.6-3.87 3.75a27.6 27.6 0 00-8.85-1.6c-.48-2.32-1.21-4.46-2.29-4.93-2.56-1.12-9.74 1.34-10.5 2.24-.43.5-.48 2.86-.05 5.59a27.61 27.61 0 00-7.13 5.1c-2.07-1.38-4.25-2.5-5.4-2.05-2.6 1.02-5.93 7.83-5.84 9.01.06.7 1.88 2.57 4.32 4.28a27.58 27.58 0 00-1.34 8.27c-2.62.48-5.24 1.25-5.76 2.45-1.12 2.56 1.34 9.74 2.24 10.5z",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.43 61.18a17.21 17.21 0 005.85-5.57 17.18 17.18 0 002.4-13.02 17.18 17.18 0 00-7.5-10.9 17.18 17.18 0 00-13.02-2.4 17.18 17.18 0 00-10.9 7.51 17.17 17.17 0 00-2.4 13.01 17.18 17.18 0 007.5 10.9 17.34 17.34 0 0018.06.47zm-17.57-30.4a17.83 17.83 0 0126.33 11.7c.99 4.66.11 9.42-2.48 13.4-2.58 4-6.57 6.75-11.22 7.74-4.65 1-9.41.11-13.4-2.47-4-2.6-6.74-6.58-7.73-11.23-1-4.65-.12-9.4 2.47-13.4a17.72 17.72 0 016.03-5.74z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.31 56.44l.35-.03a25.31 25.31 0 0117.75-35.3 25.35 25.35 0 0123.7 7.37l.32-.14a25.68 25.68 0 00-43.83 22.9c.39 1.83.97 3.56 1.71 5.2M110.04 62.24a25.2 25.2 0 01-14.05 8.42l-.33.07.17.3.23-.05a25.53 25.53 0 0014.18-8.48 7.8 7.8 0 01-.2-.26",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.8 136.7a15.22 15.22 0 11-28.92-9.48 15.22 15.22 0 0128.93 9.47zm-8.63-45.72c-.86.3-2.62 3.31-3.9 6.99-3.35-.2-6.66.11-9.85.88-1.41-3.1-3.23-6.21-4.9-6.47-3.38-.52-11.11 4.64-11.74 5.95-.4.84.52 4.32 2.28 7.9a33.84 33.84 0 00-6.4 7.4c-3.2-1.2-6.71-2.12-8.07-1.12-2.76 2.02-4.58 11.14-4.1 12.5.3.86 3.3 2.62 6.95 3.9-.3 3.4-.1 6.76.59 10-2.98 1.4-5.89 3.15-6.13 4.76-.53 3.38 4.63 11.11 5.94 11.73.78.38 3.85-.4 7.15-1.91 2.2 2.69 4.81 5.07 7.8 7-1 2.92-1.67 5.88-.77 7.11 2.02 2.76 11.14 4.58 12.5 4.1.78-.28 2.27-2.72 3.5-5.87 3.7.37 7.37.12 10.89-.68 1.3 2.6 2.84 4.92 4.27 5.14 3.38.52 11.11-4.64 11.74-5.95.34-.71-.3-3.4-1.6-6.4a33.83 33.83 0 007.16-8.39c2.75.92 5.47 1.47 6.63.62 2.76-2.03 4.58-11.15 4.1-12.51-.28-.77-2.73-2.28-5.9-3.5.25-3.65-.12-7.26-1.01-10.7 2.75-1.34 5.27-2.96 5.5-4.45.52-3.38-4.64-11.12-5.94-11.74-.79-.37-3.88.4-7.2 1.94a33.82 33.82 0 00-7.93-6.52c1.1-3.07 1.9-6.32.95-7.61-2.02-2.76-11.14-4.58-12.5-4.1z",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.86 131.68c-.01 3.3.76 6.6 2.3 9.63a21.05 21.05 0 0012.3 10.56 21.06 21.06 0 0016.18-1.23 21.06 21.06 0 0010.56-12.3 21.06 21.06 0 00-1.24-16.18 21.05 21.05 0 00-12.3-10.56 21.05 21.05 0 00-16.18 1.23 21.25 21.25 0 00-11.62 18.84zm43.04.12a21.88 21.88 0 01-11.98 19.4 21.68 21.68 0 01-16.65 1.27 21.68 21.68 0 01-12.68-10.87 21.68 21.68 0 01-1.27-16.66 21.68 21.68 0 0110.88-12.67 21.68 21.68 0 0116.65-1.27 21.68 21.68 0 0112.68 10.87 21.74 21.74 0 012.37 9.93z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.67 100.57l-.18.39a31.1 31.1 0 0126.47 40.57 31.07 31.07 0 01-22.42 20.56l-.06.42a31.47 31.47 0 0022.86-20.86 31.5 31.5 0 00-26.67-41.08M141.2 142.26a30.89 30.89 0 01-.27-20.07l.14-.39h-.43l-.1.27a31.29 31.29 0 00.26 20.25l.4-.06",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.5 46.38)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.47 12.7c-2.06 8.96 19.06 10.12 27.77 10.21 2.41.03 4.81-.2 7.18-.68 7.36-1.5 23.48-5.41 21.22-10.74C53.72 4.6 44.96 9.4 44.96 9.4s1.1-5.19-13.8-8.62c-14.9-3.43-14.85 8-14.85 8S3.06 1.45.47 12.7",
    fill: "url(#e)",
    mask: "url(#f)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.36 109.3s-5.03-41.9-34.88-50C7 102.17 49.26 133.03 49.26 133.03l24.1-23.74",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.48 59.3l-.32.44 18.08 46.33-29.2-10.48.12 1.02 29.53 10.6 5.21 13.38.72-.71-10.4-26.65 10.3-14.74c-.18-.29-.35-.57-.54-.85L51.82 92.19 39.04 59.46l-.56-.17",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.23 108.2S33.2 75.54 1.2 84.74c-7.47 34.82 30.1 49.05 30.1 49.05l36.8-1.18-5.87-24.4",
    fill: "#FACB57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.86 88.24l-.77 18.65L1.87 84.54l-.67.2-.08.4 16.72 11.97-16.9 3.92.11.48.1.42 17.7-4.1 27.86 19.94-29.43 7.82.93.71 29.48-7.83 19.79 14.16.62-.02-.28-.87L34 107.54l.78-18.9-.9-.4",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.66 125.55s-34.69-5.55-46.6 14.82c10.34 19.52 27.65 24.7 43.37 24.58 18.93-.15 36.46-10 46.86-25.81l7-10.65-50.63-2.94",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.06 140.37l.27.49 47.42 3.88-17.76 18.85 1.06.22 17.88-18.97 35.23 2.25.96-1.22-54.74-3.48-12.82-14.95a43 43 0 00-.96.32l12.46 14.52-28.73-2.35-.27.44",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A0D2BB",
    d: "M197.43 12.75l3.13 2.87-4.11.55-14.48.74 15.46-4.16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5BBDB7",
    d: "M200.56 15.62l-6.59 2 1.28-1.39 5.3-.6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(181.64 8.7)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g"
  })), /*#__PURE__*/React.createElement("path", {
    mask: "url(#h)",
    d: "M15.79 4.05L15.63.18.33 8.22l15.46-4.17"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(181.64 15.94)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i"
  })), /*#__PURE__*/React.createElement("path", {
    mask: "url(#j)",
    d: "M.32.97L14.8.23l-.07 5.7L.33.97"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M200.46 19.72a.32.32 0 00-.12-.52 9.03 9.03 0 00-1.61-.44.32.32 0 10-.11.64c.5.08 1 .22 1.5.4.12.05.26.02.34-.08M195.5 30.69c-.99-.08-2.07.21-2.88.77a.32.32 0 11-.36-.53 5.22 5.22 0 013.3-.89.32.32 0 01-.05.65zm-3.76 5.34a.32.32 0 01-.45-.09 3.59 3.59 0 01-.66-2.5c.04-.31.13-.62.26-.9a.32.32 0 11.59.25c-.1.24-.17.48-.2.73-.1.7.09 1.4.54 2.06a.32.32 0 01-.08.45zM204.6 22.8a.32.32 0 01-.45-.05 10.3 10.3 0 00-2.35-2.1.32.32 0 11.35-.54 10.45 10.45 0 012.5 2.23.32.32 0 01-.05.46zm-4.56 9.93a11.99 11.99 0 00-2.73-1.6.32.32 0 01-.18-.42.32.32 0 01.42-.19c.89.36 1.8.9 2.87 1.7.15.1.18.3.07.45l-.02.02a.32.32 0 01-.43.04zm-4.08 5.8a6.9 6.9 0 01-3.18-1.14.32.32 0 11.35-.55 6.27 6.27 0 002.9 1.04.32.32 0 11-.07.64zm10.7-11a.32.32 0 01-.38-.25 9.8 9.8 0 00-1.07-2.96.32.32 0 11.57-.31c.55 1 .94 2.06 1.14 3.15a.32.32 0 01-.26.38zm-5.45 10.08c-1.04.49-2.13.8-3.23.92a.32.32 0 11-.07-.64 9.45 9.45 0 003.02-.87.32.32 0 01.28.59zm4.69-4.99a.32.32 0 01-.17-.42 8.2 8.2 0 00.7-3.04c0-.18.15-.32.33-.32.18.01.32.16.31.34a8.87 8.87 0 01-.8 3.37c-.1.1-.24.13-.37.07zm-1.44 3.44a.32.32 0 01-.46.01 24.8 24.8 0 00-.2-.18c-.27.24-.56.47-.86.69a.32.32 0 11-.38-.52c.27-.2.52-.4.76-.61a51.2 51.2 0 00-1.76-1.51.32.32 0 11.41-.5c.67.55 1.27 1.06 1.82 1.57.37-.37.7-.76 1-1.18.1-.14.3-.17.45-.07.15.1.18.3.08.45-.32.43-.67.85-1.05 1.23l.17.17c.13.12.14.32.02.45zm3.4 3.95a.32.32 0 01-.45-.08 23.5 23.5 0 00-2.04-2.48.32.32 0 11.47-.44c.8.84 1.5 1.7 2.1 2.55a.32.32 0 01-.08.45zm2.23 4.7a.32.32 0 01-.4-.23l-.04-.14c-.3-.94-.7-1.87-1.21-2.79a.32.32 0 01.56-.31c.53.95.96 1.93 1.26 2.91l.05.15a.32.32 0 01-.22.4zm.17 5.17a.32.32 0 01-.26-.37c.16-1.05.19-2.11.07-3.17a.32.32 0 01.64-.07c.13 1.11.1 2.24-.08 3.34a.32.32 0 01-.37.27zm-2.18 4.68a.32.32 0 01-.05-.46 9.09 9.09 0 001.5-2.75.32.32 0 01.61.21 9.73 9.73 0 01-1.62 2.97.32.32 0 01-.44.03zM207.09 55.9a.32.32 0 00-.43-.48c-.42.3-.87.57-1.34.77a.32.32 0 10.26.6 7.59 7.59 0 001.5-.89",
    fill: "#A0D2BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.67 101.8a69.74 69.74 0 11-139.47 0 69.74 69.74 0 01139.47 0",
    fill: "#FACB57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.1 157.18a54.11 54.11 0 110-108.22 54.11 54.11 0 010 108.22zm-.16-125.1a69.74 69.74 0 100 139.46 69.74 69.74 0 000-139.47z",
    fill: "#13374D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.05 141.71a37.93 37.93 0 110-75.85 37.93 37.93 0 010 75.85zm-.11-87.68a48.88 48.88 0 100 97.75 48.88 48.88 0 000-97.75z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.37 128.22a23.8 23.8 0 110-47.6 23.8 23.8 0 010 47.6",
    fill: "#D0D1CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.98 103.71a29.75 29.75 0 11-59.5 0 29.75 29.75 0 0159.5 0",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.99 104.16a11.05 11.05 0 11-22.1 0 11.05 11.05 0 0122.1 0",
    fill: "#13374D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.77 104.16a5.83 5.83 0 11-11.66 0 5.83 5.83 0 0111.66 0",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.9 67.27c-5.34 3.84-9.85 9.39-10.84 12.27-.05.07-.1.3-.13.59l-.08.03.07.06v.08l.07-.03c.21.18.42.3.51.33 2.75 1.3 9.86 1.99 16.35.88 9.75-1.67 16.38-4.36 16.98-7.8.41-2.32-2.16-4.93-9.41-3.72 4.65-2.67 6-7.71 4.06-9.05-2.86-1.98-9.54.58-17.58 6.36",
    fill: "#EE9E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.9 82c2.04 4.61 1.37 9-.72 12.45l-.27.2c.05.02.09.04.13.04l-.07.12.2-.08c3.96.98 7.56 3.67 9.35 8.46 18.06-5.75 34.88-27.42 34.93-27.47 0 0-26.84-2.09-43.55 6.28",
    fill: "#FACB57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.04 81.42c-9.42 3.55-15.04 13.8-13.84 16.92.13.34.31.66.5.96.08.36.17.7.32 1.05 1.31 3.06 12.5 6.48 21.72 2.45-1.51-4.11-3.2-8-4.43-10.66a152.2 152.2 0 00-4.27-10.72",
    fill: "#EE9E35"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE9E35",
    d: "M125.96 100.36l-13.43 4.6 12.39-7.51 1.04 2.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B2441",
    d: "M147.76 128.54l-17.34 58.1h2l17.34-58.1h-2M165.92 128.54l-17.34 58.1h2l17.34-58.1h-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B2441",
    d: "M147.84 128.54v1.6h18.82l.3-1.6h-19.12M144.62 139.95v1.75l18.82-.01.33-1.76-19.15.02M141.3 151.95l-.76 1.75h18.82l.32-1.76H141.3M137.77 163.95l-.76 1.75h18.82l.32-1.76h-18.38M134.46 175.68l-.76 1.76 18.82-.01.32-1.76-18.38.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21837F",
    d: "M228.66 128.54l17.33 58.1h2l-17.33-58.1h-2M210.5 128.54l17.33 58.1h2l-17.34-58.1h-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21837F",
    d: "M211.46 128.54l.3 1.6h18.81v-1.6h-19.11M233.79 139.95v1.75l-18.82-.01-.32-1.76 19.14.02M237.12 151.95l.76 1.75h-18.82l-.33-1.76h18.39M240.64 163.95l.76 1.75H222.6l-.33-1.76h18.38M243.95 175.68l.76 1.76-18.82-.01-.32-1.76 18.38.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005C5A",
    d: "M144.3 130.15h91.82v-2.9H144.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3 197.6l5.26-.01c.7.07 1.48.27 1.6.88 0 0 .1.4.08.8-.18.22-7.16-.03-7.16-.03l-.03-.03c-.74-.89.24-1.62.24-1.62",
    fill: "#17324A"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B2441",
    d: "M99.24 199.27l-7.16-.03.06.28h7.11v-.25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M94.37 197.59h.48l-.15.65h-.46l.13-.65M95.4 197.59h.47l-.15.65h-.46l.13-.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.93 195.84l.36 1.75c.42.22.97.23 1.41.04l.08-.04.26-1.75h-2.11",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.99 197.6l5.26-.01c.7.07 1.48.27 1.61.88 0 0 .1.4.08.8-.19.22-7.17-.03-7.17-.03l-.03-.03c-.74-.89.25-1.62.25-1.62",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B2441",
    d: "M86.94 199.27l-7.17-.03.06.28h7.12l-.01-.25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M82.07 197.59h.48l-.15.65h-.46l.13-.65M83.09 197.59h.47l-.15.65h-.46l.14-.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.22 195.84l-.23 1.75c.42.22.97.23 1.4.04l.09-.04.84-1.75h-2.1M88.07 136.87l-4.33 2.83 1.34 3.43.06.14.29-.02h.09c1.16 0 2.16.72 2.76 1.68.7-.05 1.4-.22 2.05-.53.44-.21.82-.46.96-.73.47-2.43-3.22-6.8-3.22-6.8M93.59 137.76s.53 5.03-.54 8.23c.5.44 2.32 2.39 2.89-.14.57-2.53-.64-8.98-.64-8.98l-1.71.89",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21837F",
    d: "M90.99 137.4l-1.02.66.36.76 1.1-.48-.44-.94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.38 138.32c.1.23.11.45.02.5-.1.04-.25-.12-.35-.35-.1-.24-.11-.46-.02-.5.1-.04.25.12.35.35M103.3 133.7v-.04c-.2-.43-.53-1.13-.99-1.77a8.87 8.87 0 01-.95-1.55l-10.53 6.9.68 1.29 11.78-4.36a3.25 3.25 0 010-.48",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC967C",
    d: "M87.12 144.93l-.38 2.37h3.35l.24-2.9-3.21.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.77 150.8s3.96-1.26 5.2-2.96c1.24-1.69-.86-10.97-.86-10.97l.27-1.67c.16-.94-.57-1.8-1.52-1.8l-1.05-.01a.6.6 0 00-.56.85l1.39 3.13s1.04 7.03-.42 7.56c-1.74.62-3.72.77-3.72.77l1.27 5.1",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.33 144.93l-1.01-2.26.66-.41c.49-.31.7-.91.51-1.46l-.72-2.13s2.06-.25 2-2.17c0-.99-1.36-1-1.36-1s-.41.89-1.67 1c-.55-.07-2.03.12-3.04 1.88-.67 1.18-.38 3.02.21 4.41.53 1.24 1.87 1.94 3.2 2.14h1.22",
    fill: "#EE9E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3 163.9s.22 4.82 1.26 10.04c.3 1.54.2 3.13-.3 4.61-2.37 7.03-5.69 17.59-5.69 17.59h2.95s6.68-12.48 8.4-18.68c1.72-6.19 2.02-8.15 2.02-8.15l-2.05-5.4h-6.58",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.77 141.62c-.12.36.12.83.55 1.05.42.23.86.12.98-.23.12-.36-.12-.83-.54-1.06-.43-.22-.87-.12-1 .24",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.92 163.9h-9.61v-12.33c0-2.7 2.05-4.96 4.74-5.2l6.69-.82s.79 1.2 2.97 4a22.56 22.56 0 01-5.67 2.38l.88 11.97",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3 163.9s1.37 4.92 6.38 10.42a6.44 6.44 0 011.86 5.01l-1.03 16.8h3s3.64-13.95 2.85-20.83a31.58 31.58 0 00-3.44-11.4h-9.61",
    fill: "#13374D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.68 132.55c.52 1.07 1.22 1.8 1.57 1.64.34-.17.2-1.18-.3-2.25-.53-1.07-1.23-1.8-1.58-1.64-.34.17-.2 1.18.3 2.25",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.17 135.7l.09.05c.31.15.67.17 1 .06l.06-.02c.55-.18.97-.6 1.14-1.15a.33.33 0 00-.38-.43l-.67.14a1 1 0 00-.63.43l-.6.93",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.66 175.58c1.51 10.82-.14 22.03-.14 21.93 0-.1-1.21 0-1.21 0s-1.67-13.15-2.06-17.54c-.4-4.39 0-4.68 0-4.68s1.9-10.53 3.4.3",
    fill: "#AD6044"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A0D2BB",
    d: "M136.06 147.67l3.7 2.35 1.56-3.25-4.78-5.48-.48 6.38"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD6044",
    d: "M116.53 126l4.53 11.84 2.9-2.15-6.47-10.9-.96 1.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.27 121.99c.36.28.6.7.67 1.15l.55 1.65-.18.31-.78.9c-.04-.35-.3-.61-.3-.61l-1.24-1.38s-2.02-2.36-.13-3.16c-1.11-2.2-.32-2.13-.32-2.13l1.73 3.27",
    fill: "#AD6044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.99 122.42s.4-.39.04-1.3c-.36-.91.19-.85.19-.85s1.5 3.56 1.02 3.97c-.48.4-1.25-1.82-1.25-1.82",
    fill: "#AD6044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.51 140.27l-1.35.1-4.61-5.37-2.49 2.84s2.28 4.3 5.62 8.77c.2.9 1.18 10.04 1.18 10.04h8s-1.28-6.7.97-10.43c2.25-3.73-7.32-5.95-7.32-5.95",
    fill: "#A0D2BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.13 175.58c1.51 10.82-.14 22.03-.14 21.93 0-.1-1.2 0-1.2 0s-1.68-13.15-2.07-17.54c-.4-4.39 0-4.68 0-4.68s1.9-10.53 3.41.3M129.22 131.91l4.6 1.62-.45 3.43c0 .05-.02.1-.03.14l-.26.06-.05.01H133a3.15 3.15 0 00-2.15 2.16c-.65.11-1.33.11-1.99-.02-.45-.1-.86-.24-1.05-.45-.97-2.12 1.42-6.95 1.42-6.95",
    fill: "#AD6044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.1 134.8c.42.84.5 1.81.1 2.65a4.45 4.45 0 00-.16 3.63 4.84 4.84 0 001.69 1.52 2.6 2.6 0 011.22 1.97c.1 1.12.21 2.49 1.17 2.82 2.77.96 3.8.86 4.16-1.45.1-.6.07-1.46-.24-2.27a4.06 4.06 0 01.09-3.04c.28-.63.52-1.33.52-1.81 0-.53-.48-1.27-.98-1.9a3.9 3.9 0 01-.82-2.78c.09-1-.05-2.29-1.07-3.15-1.9-1.62-6.1.92-6.1.92s-.41 1.23.42 2.9",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.32 146.77l1.77 1.84c1.18 1.22 1.55 2.93.13 3.86l-5.8 4.61.53 1c.45.84.36 1.87-.22 2.63l-.6.8-1.37-4.66 4.21-5.26a1 1 0 00-.21-1.57l1.56-3.25",
    fill: "#AD6044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.86 156.65s-1.17 3.03-1.17 6.1c0 1.7 1.47 14.44 1.47 14.44h7.6c-.51-9.4 2.34-10.56 2.34-14.63 0-2.87-2.25-5.91-2.25-5.91h-7.99M135.52 196.1s.66.52.54 1.18c-.12.67-.3 2.23-.3 2.23h-.68l.02-1.45c0-.1-1.47 1.45-1.71 1.45h-3.62s-.24-.98 1.88-1.3c2.13-.31 3.87-2.12 3.87-2.12",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.65 196.1s.67.52.54 1.18c-.12.67-.29 2.23-.29 2.23h-.68l.02-1.45c0-.1-1.47 1.45-1.72 1.45h-3.62s-.24-.98 1.89-1.3c2.12-.31 3.86-2.12 3.86-2.12",
    fill: "#17324A"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M84.76 57.1l-12.7-1.4-5.7 1.14-3.74 2.25 22.14-1.99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A0D2BB",
    d: "M84.76 57.1l-21.4 3.08-.74-1.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5BBDB7",
    d: "M64.19 63.73l.04.03 2.06 2.66 18.42-9.3-20.52 6.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M59.77 63.5l1.82-3.38 23.03-3-18.03 6.89-6.82-.5M32.24 119.9c.54-.49 1.05-1.02 1.52-1.58a.3.3 0 01.47.39 16.26 16.26 0 01-2.2 2.17.3.3 0 01-.43-.04.3.3 0 01.04-.43l.6-.51M53.25 63.76c.92-.25 1.9-.48 2.97-.72a.3.3 0 11.13.6c-1.07.23-2.03.46-2.94.71a.3.3 0 01-.37-.21.3.3 0 01.2-.38M48.66 65.93a.3.3 0 01-.05-.58c.9-.38 1.86-.74 2.88-1.06a.3.3 0 11.19.58 33 33 0 00-2.83 1.04.3.3 0 01-.2.02M36.25 114.26a.3.3 0 01.4-.16.3.3 0 01.16.4c-.4.95-.9 1.86-1.47 2.72a.3.3 0 01-.42.09.3.3 0 01-.09-.43c.55-.82 1.03-1.7 1.42-2.62M37.06 112.95a.3.3 0 01-.2-.37 16.8 16.8 0 00.59-2.93.3.3 0 11.6.07 16.36 16.36 0 01-.6 3.03.3.3 0 01-.39.2M37.84 108.17l-.07-.01a.3.3 0 01-.23-.3c0-.94-.08-1.92-.24-2.98a.3.3 0 11.6-.09c.16 1.1.24 2.1.25 3.07a.3.3 0 01-.3.3M35.31 81.11a23.9 23.9 0 00-.68 2.92.3.3 0 01-.35.25h-.03a.3.3 0 01-.22-.35 23.82 23.82 0 01.7-3c.05-.16.2-.26.38-.2a.3.3 0 01.2.38M34.4 85.82c-.09 1-.1 2-.06 3a.3.3 0 11-.6.03c-.05-1.02-.03-2.06.05-3.08a.3.3 0 11.61.05M37.14 76.67c-.47.89-.89 1.8-1.24 2.74a.3.3 0 11-.57-.22c.36-.95.8-1.9 1.28-2.8a.3.3 0 01.54.29M40.99 71.32a.3.3 0 01-.43.01.3.3 0 01-.01-.43c.7-.74 1.47-1.45 2.26-2.09a.3.3 0 01.38.47 23.4 23.4 0 00-2.2 2.04M36.12 98.63a.3.3 0 01-.38-.2l-.1-.38c-.25-.86-.5-1.7-.72-2.57a.3.3 0 01.59-.15l.72 2.55.1.37a.3.3 0 01-.2.38M38.05 75.11a.3.3 0 01-.52-.32c.55-.87 1.15-1.71 1.8-2.5a.3.3 0 01.47.39c-.63.77-1.22 1.59-1.75 2.43M36.46 99.8a.3.3 0 01.37.2c.32 1.16.55 2.1.74 2.98a.3.3 0 01-.6.12c-.18-.86-.41-1.8-.72-2.93a.3.3 0 01.2-.37M30.2 121.48a.3.3 0 01.34.5c-.8.54-1.68 1.05-2.67 1.54a.3.3 0 11-.27-.54 24.1 24.1 0 002.6-1.5M34.17 90.35a.3.3 0 01.34.26c.12.92.3 1.88.55 2.96a.3.3 0 01-.6.14c-.25-1.1-.43-2.08-.55-3.02a.3.3 0 01.26-.34M46 66.64c.3-.18.62-.34.94-.5a.3.3 0 01.27.54 24.46 24.46 0 00-2.58 1.52.3.3 0 01-.42-.07.3.3 0 01.08-.43c.55-.38 1.12-.73 1.7-1.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.69 87.95s6.93-4.55 8.61-6.81c1.68-2.26 2.7-13.35-.58-7.3-3.28 6.06-9.28 13.14-9.28 13.14l1.25.97",
    fill: "#EC967C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.69 87.95v1.32c0 .45-.12.89-.35 1.28l-.9 1.55-.83-4.5.83-.62 1.25.97M214.4 64.61l1.07 2.87 2.98-1.32-2.66-3.95-1.38 2.4",
    fill: "#EC967C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.75 65.55c-.34.16-.68.27-.91.21-1.69-.94-2.45-5.34-2.45-5.34l1.24-1.43 2.6.27 1.38 2.52c.37.67.36 1.5-.02 2.21a4.55 4.55 0 01-1.84 1.56",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.63 60.87c-.32-.38-.75-1.4-1.16-1.11-.3.2-1.37.8-1.74.97-.89.44-2.63.86-3.3-.48-.32-.67.05-1.57.38-1.95a2 2 0 011.27-.64c1.14-.14 2.8-.02 3.26-.38.78-.6 1.9-.51 2.24.23.37.8.54 2.18.53 3.12a4.62 4.62 0 01-.32 1.58l-1.16-1.34",
    fill: "#FACB57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.58 60.53c-.28-.08-.64.14-.79.48-.15.34-.05.68.24.76.28.07.63-.14.78-.48.16-.34.05-.68-.23-.76",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21837F",
    d: "M192.87 92.73l.55.3v-.3h-.55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.4 90.05c-.01-.04-1.61-3.38 1.64-5.43 3.24-2.03 5.78 2.35 5.8 2.4l-.45.31c-.09-.16-2.3-3.95-5.1-2.19a3.53 3.53 0 00-1.42 4.62l-.47.29",
    fill: "#13374D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.18 65.56c6.11 3.69 4.67 20.4 4.67 20.4H213.7s-1.37-13.14 1.73-19.3a2.69 2.69 0 013.76-1.1",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.25 91.94l-1.13-4.6a.82.82 0 00-1.1-.58l-6.06 2.36a1 1 0 00-.4 1.6l3.17 3.71s1.52.14 3.29-.68c1.77-.82 2.23-1.81 2.23-1.81",
    fill: "#13374D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.62 92.87s-1.88-.46-6.2.16c-.06-.29-.55-.3-.55-.3l5.82-1.56.93 1.7",
    fill: "#13374D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.83 123.58s0 1.77-3.57 2.84c-.73.21-.5.43-.63.74h4.1l1.6-1.8.5.42 1.16-1.14s-.54-1.64-1.42-1.66l-1.74.6",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.16 122.04l.67 1.54a1.6 1.6 0 001.67-.5l.07-.1-.54-1.57-1.87.63",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.23 104.78c0 .2 9.08 17.6 9.08 17.6l1.72-.97s-3-14-6.4-19.78a7 7 0 01-.91-2.81c-.6-5.77-1.01-8.03-1.01-8.03l-3.6 13.08 1.12.91",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.98 76.71s-2.12 3.42-4.62 5.08c-2.49 1.66-11.63 2.4-11.63 2.4l-1.23 1.39c-.2.23-.52.3-.8.2l-.27-.1a1.06 1.06 0 01-.5-1.6l.55-.76c.2-.29.51-.47.86-.51l2.5-.29s6.74-2.02 8.3-3.64c1.58-1.62 3.69-6.5 3.69-6.5l3.15 4.33",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.74 124.28s-1.14 1.06-3.75 1.72c-.57.15-1.19-.04-1.19.9h3.16l2.63-.45v.45h1.42s.4-2.32-.43-2.62h-1.84",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.02 122.61l-.28 1.67c.52.36 1.2.38 1.74.06l.1-.06-.14-1.67h-1.42",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.69 85.96l2.2 37.01h1.8s3.45-9.18 2.22-16.43a9.1 9.1 0 01.6-5.19c3.18-7.26 3.34-15.4 3.34-15.4H213.7",
    fill: "#13374D"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(191.3 94.2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "m",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.73.4S-.15 4.38.15 6.7c.2 1.64.94 2.08 1.5 2.22a1.4 1.4 0 001.47-.6C4.66 6.04 1.72.4 1.72.4",
    fill: "url(#l)",
    mask: "url(#m)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M128.87 37.6l5.36-.94c.73-.05 1.56.02 1.8.61 0 0 .16.4.21.8-.15.26-7.3 1.24-7.3 1.24l-.03-.02c-.91-.78-.04-1.7-.04-1.7",
    fill: "#13374D"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M136.24 38.08l-7.3 1.23.12.27 7.24-1.25-.06-.25M131 37.22l.48-.08-.04.68-.47.08.02-.68M132.03 37.04l.48-.08-.03.69-.47.08.02-.69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.2 35.87l.67 1.72c.47.15 1.03.06 1.45-.21l.07-.05-.05-1.83-2.14.37",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.3 38.98l5.35-.95c.73-.05 1.56.02 1.8.6 0 0 .16.4.22.81-.15.26-7.3 1.25-7.3 1.25l-.03-.02c-.92-.77-.04-1.69-.04-1.69",
    fill: "#13374D"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M134.67 39.44l-7.3 1.25.11.28 7.24-1.28-.05-.25M129.42 38.6l.48-.08-.04.68-.46.09.02-.69M130.45 38.42l.48-.08-.03.68-.47.08.02-.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.62 37.26l.68 1.72c.47.14 1.03.06 1.44-.22l.07-.05-.05-1.83-2.14.38",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.32 27.16s1.46 6.75 7.71 6.48c6.25-.26 12.97-8 12.97-8l3.35 10.54 2.4-.16s.1-16.5-3.3-17.03c-3.42-.53-15.37 5.97-15.37 5.97l-7.76 2.2",
    fill: "#13374D"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC967C",
    d: "M107.52 7.54l-1 2.51 2.15.6.77-2.05-1.92-1.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.7 3.14l-.56 3.39c.33.06.45.46.32.76.02.08.02.17 0 .26.49.54 1.42 1.3 2.83 1.34 2.21.06 1.83-4.32 1.83-4.32l-4.42-1.43",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.08 5.43a2.1 2.1 0 00-.33-1.05c-.97-1.3.26-1.82.7-1.98.48-.18.56-.96 1.2-1.27.98-.47 1.63.38 2.19.4.55.01 1.04-.62 1.73-.08.7.55.47 1.14.67 1.45.19.3.8-.3 1.38.67.88 1.49-1.49 1.52-1.49 1.52s-1.35.25-2.84-.75c-.2-.14-.48-.15-.67.02-.5.44-1.12 3.24-1.12 3.24l-.44-.58s-1.15-.45-.98-1.6",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.3 5.98a.53.53 0 101.03-.19.53.53 0 00-1.03.19",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.5 26.72s.76 6.86 7 7.24c6.25.37 13.72-6.64 13.72-6.64l3.28 10.33 2.41-.42s.76-15.4-2.58-16.28c-3.34-.87-15.9 4.37-15.9 4.37l-7.94 1.4",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.5 26.72l10.2-1.8s-.74-2.22-.92-4.56c-.14-1.76.49-3.36.49-3.36-.65-3.9-2.17-7.68-5.62-7.2-5.88 1.6-4.16 16.92-4.16 16.92",
    fill: "#FACB57"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21837F",
    d: "M130.8 11.52l-3.35 9.14-9.06-.86-.07.72 9.62.92 3.55-9.67-.68-.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.22 17.62l4.03-.7.53 4.51 7.08-2.4 1.56-1.1a2 2 0 011.38-.34l1.97.24c.2.03.37.18.4.38l.77 2.08s-.46.35-1.26-1.39c-.3 2.1-3.3.78-3.3.78l-.97.72s-7.5 5.82-9.45 4.83c-1.95-.99-2.74-7.6-2.74-7.6",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.17 18.21a.46.46 0 00-.4-.38l-1.97-.24a2 2 0 00-1.38.35l-1.56 1.09-.23.07.3 1.67.48-.37.98-.72s2.99 1.31 3.3-.78c.79 1.74 1.25 1.39 1.25 1.39l-.77-2.08",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D29577",
    d: "M55.1 123.5l-.25 3.1-3.05.14 1.23-4.83 2.07 1.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4 124.06c.39 0 .75-.07.94-.22 1.11-1.62-.16-6-.16-6l-1.78-.75-2.27 1.41-.13 2.93c-.04.79.34 1.54 1.01 2.03.72.4 1.55.63 2.4.6",
    fill: "#D29577"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.49 120.16c.12-.49.05-1.63.56-1.54.36.06 1.62.1 2.04.1 1 0 2.8-.39 2.8-1.92 0-.76-.74-1.42-1.21-1.62-.46-.2-.99-.18-1.46-.02-1.1.39-2.58 1.24-3.16 1.13-.99-.2-1.97.38-1.96 1.21.02.9.49 2.24.92 3.1.26.5.6.94 1 1.31l.47-1.75",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.47 120.27c.22-.2.64-.16.93.09.3.24.35.6.13.8-.23.2-.65.16-.94-.08-.3-.25-.35-.6-.12-.8M63.68 125.9c.05-.14.27-.63 1.12-1.28.76-.6 2.71-1.36 1.87-1.94-1.05.08-2.28.05-2.28.05-.63.11-1.37.9-1.73 1.47l-.92 1.9.44.98.43-.09c.3-.42.67-.78 1.07-1.09",
    fill: "#D29577"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.07 125.12)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "p",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    mask: "url(#p)",
    d: "M3.82 7.23l4.9-4.55L7.02.15.33 3.3l2.92 5.13.58-1.21"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.34 124.64)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "s",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.1.11C-.87-1.34.35 21.8.35 21.8h11.05s.16-4.03.56-9.14C12.3 8.33 9.86 3.44 6.11.11",
    fill: "url(#r)",
    mask: "url(#s)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.09 184.7s1.09 1.01 3.57 1.64c.54.14 1.13-.04 1.13.86h-3l-2.51-.43v.43h-1.36s-.37-2.21.42-2.5h1.75",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.94 183.11l.15 1.6c-.5.33-1.14.36-1.66.05l-.1-.06-.27-1.59h1.88M72.75 132c.16-.02.68-.12 1.5-.8.76-.62 1.94-2.35 2.32-1.4-.32 1-.57 2.22-.57 2.22-.25.59-1.17 1.13-1.81 1.36l-2.06.46-.86-.64.18-.4c.48-.2.92-.47 1.3-.8",
    fill: "#D29577"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.45 182.48s1.1 1 3.57 1.64c.55.14 1.14-.05 1.14.86h-3.01l-2.5-.44v.44h-1.36s-.38-2.22.41-2.5h1.75",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3 180.89l.15 1.59c-.49.34-1.14.36-1.65.05l-.1-.05-.28-1.6h1.88",
    fill: "#D29577"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.68 146.43s.89 4.69.1 14.39a17.7 17.7 0 01-1.16 5c-2.13 5.45-2.42 15.52-2.42 15.52h2.43l8.59-24.54-7.54-10.37",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.7 128.02)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "v",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.1 4.37s1.92 7.11 7.1 7.77c5.18.66 13.7-5.9 13.7-5.9l-.93-1.87-9 2.52a3.05 3.05 0 01-3.5-1.49L4.77.41.1 4.37",
    fill: "url(#u)",
    mask: "url(#v)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M58.73 146.43l-1.6 37.1h-2.18s-2.44-8.64-2.26-15.46a15.8 15.8 0 00-1.12-6.32c-3.32-8.26-3.89-15.32-3.89-15.32h11.05",
    fill: "#13374D"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21837F",
    d: "M77.74 128.43l-7.82 5.89-8.94-7 7.3-5.4 9.46 6.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.29 132.07l.15.01-.14.38c-.36.36-.7.74-1.05 1.1l-.45-.57 1.8-2.85s.44.07.26.75c-.17.68-.57 1.18-.57 1.18",
    fill: "#D29577"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.67 132.37)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "y",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#w"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.68 3.42a5.61 5.61 0 00-.47-2.06L5 .02l.94 1.87S3.5 3.75.47 5.4c.16-.65.24-1.32.21-1.97",
    fill: "url(#x)",
    mask: "url(#y)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.94 132.35c.01.07 1.94 7.03 6.97 7.67 4.69.6 12.28-4.89 13.44-5.75l.18.21c-1.12.84-8.01 5.87-12.87 5.87-.27 0-.53-.02-.79-.05-5.21-.66-7.19-7.8-7.2-7.88l.27-.07",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.92 124.64c.23-.09.6-.2 1.03-.2.7-.02.67.42.67.42l-2.56.9a5.88 5.88 0 00-.08-.5c.33-.18.64-.39.94-.62",
    fill: "#D29577"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M55.1 126.4v-1.52l-2.56-1.06-.92 1.17 3.48 1.42"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardTarget);
export default __webpack_public_path__ + "static/media/card-target.cbb4dec77f05703dbab458dcce56bc33.svg";
export { ForwardRef as ReactComponent };